module.exports = __webpack_public_path__ + "7979b864de3a0fdb2822c6c5465c01ae.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/head/mythosgoldencity.jpg
// module id = 635
// module chunks = 0